var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Menu'),_c('h1',{staticClass:"title is-5 ch-tieu-de"},[_vm._v(_vm._s(_vm.lang('Cấu hình Site')))]),_c('SettingsUpload'),_c('SettingsSecurity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }